export const brickFormDefaults = {
  name: "",
  plannedStartDate: null,
  plannedEndDate: null,
  plannedHours: "",
  user: null,
  message: "Ciao, ti ho assegnato un nuovo brick",
  checklists: [],
  skillsIds: [],
};
